import styled from 'styled-components';

const AddressFieldStyle = styled.div`
	--suggestedMenuMaxHeight: var(--sp40x);
	--distanceTopDropdownContainer: var(--sp1x);
	--radiusDropdownContainer: var(--sp1x);
	--distanceDropdownContainerGap: var(--sp0-5x);
	--menuItemPadding: var(--sp1-5x) var(--form_inputPadTBL);

	position: relative;

	.suggested-container {
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background: var(--mainColor);
		box-shadow: 0px 4px 20px var(--form_boxShadowColor);
		padding: 0;
		z-index: 9999;
		border-radius: var(--radiusDropdownContainer);
		margin-top: var(--distanceTopDropdownContainer);
		overflow: hidden;

		.suggested-menu {
			max-height: var(--suggestedMenuMaxHeight);
			overflow-y: auto;

			display: flex;
			flex-direction: column;
			gap: var(--distanceDropdownContainerGap);

			.suggested-menu-item {
				display: flex;
				flex-direction: column;
				gap: var(--sp1x);
				padding: var(--menuItemPadding);
				cursor: pointer;
				border-radius: var(--radiusDropdownContainer);
			}

			.suggested-menu-subtitle {
				color: var(--neutral800);
			}
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.suggested-menu-item {
				&:hover {
					background-color: var(--neutral25);
				}
			}
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--suggestedMenuMaxHeight: var(--sp30x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--suggestedMenuMaxHeight: var(--sp25x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
	}
`;

export default AddressFieldStyle;
